import { useEffect } from "react";
import { useAuth } from "react-oidc-context";
import styled from "styled-components";
import { FiAlertTriangle } from "react-icons/fi";
import { Card, Button, PageTitle } from "../components/ui";

const Page = styled.div`
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: ${({ theme }) => theme.space(6)};
  background: ${({ theme }) => theme.colors.bg};
`;

const Panel = styled(Card)`
  width: 100%;
  max-width: 440px;
  text-align: center;
  padding: ${({ theme }) => theme.space(8)};
`;

const IconWrap = styled.div`
  width: 56px;
  height: 56px;
  border-radius: 50%;
  background: ${({ theme }) => theme.colors.dangerSoft};
  color: ${({ theme }) => theme.colors.danger};
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto ${({ theme }) => theme.space(4)};
  svg { width: 24px; height: 24px; }
`;

const Sub = styled.p`
  color: ${({ theme }) => theme.colors.textMuted};
  margin-top: ${({ theme }) => theme.space(2)};
  margin-bottom: ${({ theme }) => theme.space(6)};
`;

function Unauthorized() {
  const auth = useAuth();

  // Full reload to "/" — react-router's soft navigate would leave sticky
  // OIDC error state (auth.error) and PreSignUp query params behind, and the
  // App gate would just bounce back to this same Unauthorized screen.
  const returnToLogin = () => {
    try { auth.removeUser?.(); } catch { /* ignore */ }
    window.location.replace("/");
  };

  useEffect(() => {
    const timer = setTimeout(returnToLogin, 5000);
    return () => clearTimeout(timer);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Page>
      <Panel>
        <IconWrap><FiAlertTriangle /></IconWrap>
        <PageTitle>Access denied</PageTitle>
        <Sub>You're not authorized to access this portal. Redirecting to login in 5 seconds…</Sub>
        <Button onClick={returnToLogin}>Return to login</Button>
      </Panel>
    </Page>
  );
}

export default Unauthorized;
